var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import * as API from '../apis/AjaxApis';
import * as DOMData from '../apis/DOMData';
import { calculateSeatState } from '../util';
var initialState = {
    priceBands: {},
    seats: {},
    labels: [],
    ticketSelections: {},
    boxSize: { height: 0, width: 0 },
    performanceRef: 'UNKNOWN',
    loadingSeatmap: true,
    pollInProgress: false,
    feedback: {
        isError: false,
        message: null
    }
};
export var fetchInitialSeatmap = createAsyncThunk('seatmap/fetchInitialSeatmap', function (performanceId, _a) {
    var dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatch(clearData());
                    return [4 /*yield*/, API.getSeatMap(performanceId)];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
});
export var fetchSelectionsForPerformance = createAsyncThunk('seatmap/fetchSelectionsForPerformance', function (_, _a) {
    var getState = _a.getState, dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, performanceId, data;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    performanceId = state.seatmap.performanceRef;
                    if (performanceId === initialState.performanceRef)
                        return [2 /*return*/];
                    return [4 /*yield*/, API.getBasketItemsForPerformance(performanceId)];
                case 1:
                    data = (_b.sent()).data;
                    dispatch(addTicketSelections(data.map(function (item) { return ({ item: item, status: 'success' }); })));
                    return [2 /*return*/];
            }
        });
    });
});
export var pollSeatmapUpdates = createAsyncThunk('seatmap/pollSeatmapUpdates', function (_, _a) {
    var getState = _a.getState, dispatch = _a.dispatch;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, ret;
        return __generator(this, function (_b) {
            state = getState();
            if (state.seatmap.pollInProgress) {
                return [2 /*return*/, null];
            }
            dispatch(setIsPolling(true));
            ret = API.getSeatMap(state.seatmap.performanceRef, state.seatmap.lastUpdated);
            dispatch(setIsPolling(false));
            return [2 /*return*/, ret];
        });
    });
});
export var addTicketsToBasket = createAsyncThunk('seatmap/addTicketsToBasket', function (_a, _b) {
    var ticketSelections = _a.ticketSelections, _c = _a.deleteOnError, deleteOnError = _c === void 0 ? false : _c;
    var dispatch = _b.dispatch, getState = _b.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, onError;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch(addTicketSelections(ticketSelections.map(function (item) { return ({ item: item, status: 'pending' }); })));
                    state = getState();
                    onError = function (message) {
                        if (deleteOnError) {
                            dispatch(deleteTicketSelections(ticketSelections.map(function (item) { return item.seatId; })));
                        }
                        else {
                            dispatch(addTicketSelections(ticketSelections.map(function (item) { return ({ item: item, status: 'error', message: message }); })));
                        }
                        dispatch(setMessage({ message: message, isError: true }));
                    };
                    return [4 /*yield*/, API.addToBasket(ticketSelections, state.seatmap.performanceRef).then(function (response) {
                            if (response.message.className === 'alert-danger') {
                                onError(response.message.text);
                            }
                            else {
                                dispatch(addTicketSelections(ticketSelections.map(function (item) { return ({ item: item, status: 'success' }); })));
                                DOMData.updateBasketPrice(response.basket.total);
                                dispatch(fetchSelectionsForPerformance());
                                dispatch(clearMultiTicketSelections());
                            }
                        }).catch(function (error) {
                            onError(error.message);
                        })];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    });
});
export var addMultiSelectTicketsToBasket = createAsyncThunk('seatmap/addMultiSelectTicketsToBasket', function (_, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, ticketSelections;
        return __generator(this, function (_b) {
            state = getState();
            ticketSelections = state.seatmap.multiTicketSelectsion;
            if (!ticketSelections) {
                return [2 /*return*/];
            }
            return [2 /*return*/, dispatch(addTicketsToBasket({ ticketSelections: ticketSelections, deleteOnError: true }))];
        });
    });
});
export var removeSeatFromBasket = createAsyncThunk('seatmap/removeSeatFromBasket', function (seatId, _a) {
    var dispatch = _a.dispatch, getState = _a.getState;
    return __awaiter(void 0, void 0, void 0, function () {
        var state, seat, onError, res;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    state = getState();
                    seat = state.seatmap.ticketSelections[seatId];
                    onError = function (message) {
                        dispatch(addTicketSelections([__assign(__assign({}, seat), { status: 'success' })]));
                        dispatch(setMessage({ message: message, isError: true }));
                    };
                    dispatch(addTicketSelections([__assign(__assign({}, seat), { status: 'pending' })]));
                    return [4 /*yield*/, API.removeFromBasket(seatId, state.seatmap.performanceRef).then(function (response) {
                            if (response.message.className === 'alert-danger') {
                                onError(response.message.text);
                            }
                            else {
                                dispatch(deleteTicketSelections([seatId]));
                                DOMData.updateBasketPrice(response.basket.total);
                                dispatch(setMessage({ message: response.message.text, isError: false }));
                            }
                        }).catch(function (error) {
                            onError(error.message);
                        })];
                case 1:
                    res = _b.sent();
                    return [2 /*return*/, res];
            }
        });
    });
});
var slice = createSlice({
    name: 'seatmap',
    initialState: initialState,
    reducers: {
        setIsPolling: function (state, action) {
            state.pollInProgress = action.payload;
        },
        addTicketSelections: function (state, action) {
            action.payload.forEach(function (ticketSelection) {
                state.ticketSelections[ticketSelection.item.seatId] = ticketSelection;
            });
        },
        deleteTicketSelections: function (state, action) {
            action.payload.forEach(function (seatId) {
                delete state.ticketSelections[seatId];
            });
        },
        clearData: function (state) {
            state = __assign({}, initialState);
        },
        setMessage: function (state, action) {
            if (!action.payload) {
                state.feedback = initialState.feedback;
            }
            else {
                state.feedback = action.payload;
            }
        },
        clearMessage: function (state) {
            state.feedback = initialState.feedback;
        },
        addToMultiTicketSelection: function (state, action) {
            if (!state.multiTicketSelectsion) {
                state.multiTicketSelectsion = [action.payload];
            }
            else {
                state.multiTicketSelectsion.push(action.payload);
            }
        },
        removeFromMultiTicketSelection: function (state, action) {
            if (state.multiTicketSelectsion) {
                state.multiTicketSelectsion = state.multiTicketSelectsion.filter(function (_a) {
                    var seatId = _a.seatId;
                    return !action.payload.seatIds.includes(seatId);
                });
            }
        },
        clearMultiTicketSelections: function (state) {
            state.multiTicketSelectsion = undefined;
            state.feedback = initialState.feedback;
        }
    },
    extraReducers: function (builder) {
        builder.addCase(fetchInitialSeatmap.fulfilled, function (state, action) {
            if (!action.payload) {
                return;
            }
            var _a = action.payload, size = _a.size, priceBands = _a.priceBands, seats = _a.seats, labels = _a.labels, performanceRef = _a.performanceRef;
            state.seats = seats;
            state.loadingSeatmap = false;
            state.priceBands = priceBands;
            state.labels = labels;
            state.boxSize = size;
            state.performanceRef = performanceRef;
        });
        builder.addCase(fetchInitialSeatmap.pending, function (state) {
            state.loadingSeatmap = true;
        });
        builder.addCase(pollSeatmapUpdates.fulfilled, function (state, action) {
            if (!action.payload) {
                return;
            }
            var _a = action.payload, priceBands = _a.priceBands, seats = _a.seats;
            state.seats = __assign(__assign({}, state.seats), seats);
            state.priceBands = __assign(__assign({}, state.priceBands), priceBands);
            state.lastUpdated = action.payload.lastUpdate;
        });
    }
});
export var addTicketSelections = (_a = slice.actions, _a.addTicketSelections), deleteTicketSelections = _a.deleteTicketSelections, clearData = _a.clearData, setMessage = _a.setMessage, addToMultiTicketSelection = _a.addToMultiTicketSelection, clearMultiTicketSelections = _a.clearMultiTicketSelections, removeFromMultiTicketSelection = _a.removeFromMultiTicketSelection, clearMessage = _a.clearMessage, setIsPolling = _a.setIsPolling;
export default slice.reducer;
var selectSeats = function (state) { return state.seatmap.seats; };
var selectPriceBands = function (state) { return state.seatmap.priceBands; };
var selectTicketSelections = function (state) { return state.seatmap.ticketSelections; };
var selectMultiSelect = function (state) { return state.seatmap.multiTicketSelectsion; };
export var selectIsLoading = function (state) { return state.seatmap.loadingSeatmap; };
export var currentPerformanceRef = function (state) { return state.seatmap.performanceRef; };
export var selectComputedMultiSelection = createSelector([selectMultiSelect, selectPriceBands], function (multiSelect, priceBands) {
    if (!multiSelect || !multiSelect.length) {
        return { enabled: false };
    }
    else {
        var firstEl_1 = multiSelect[0];
        var priceBand = priceBands[firstEl_1.priceBandId];
        return {
            enabled: true,
            priceBand: priceBand,
            concession: priceBand.concessions.find(function (_a) {
                var id = _a.id;
                return firstEl_1.concessionId === id;
            }),
            seats: multiSelect.map(function (_a) {
                var seatId = _a.seatId;
                return seatId;
            })
        };
    }
});
export var selectComputedSeatmap = createSelector([selectSeats, selectPriceBands, selectTicketSelections, selectComputedMultiSelection, selectIsLoading], function (seats, priceBands, selections, multiSelections, isLoading) {
    var ret = {};
    if (isLoading) {
        return ret;
    }
    Object.entries(seats).forEach(function (_a) {
        var seatId = _a[0], seat = _a[1];
        var selection = selections[seatId];
        var priceBand = priceBands[seat.priceBandId];
        ret[seatId] = {
            seat: seat,
            priceBand: priceBand,
            state: calculateSeatState(seat, priceBand, multiSelections, selection)
        };
    });
    return ret;
});
